import { render, staticRenderFns } from "./CourseTableMore.vue?vue&type=template&id=ed5478d4"
import script from "./CourseTableMore.vue?vue&type=script&lang=js"
export * from "./CourseTableMore.vue?vue&type=script&lang=js"
import style0 from "./CourseTableMore.vue?vue&type=style&index=0&id=ed5478d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports